var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M460.728,104.864V93.947c0-19.975-16.251-36.227-36.227-36.227h-43.823c-19.975,0-36.226,16.251-36.226,36.227v9.53 H215.806V76.267c0-26.762-21.772-48.534-48.534-48.534H97.047c-26.762,0-48.534,21.772-48.534,48.534v30.604 c0,0.606,0.036,1.201,0.091,1.792C20.193,119.738,0,147.374,0,179.656v240.026c0,35.613,28.972,64.585,64.585,64.585h382.83 c35.613,0,64.585-28.972,64.585-64.585v-251.62C512,137.012,489.975,111.017,460.728,104.864z M256,405.96 c-61.092,0-110.792-49.7-110.792-110.792c0-61.091,49.7-110.791,110.792-110.791s110.792,49.7,110.792,110.791 C366.792,356.259,317.091,405.96,256,405.96z M420.36,214.598c-12.656,0-22.953-10.297-22.953-22.953 c0-12.657,10.297-22.954,22.953-22.954c12.657,0,22.954,10.297,22.954,22.954C443.314,204.301,433.018,214.598,420.36,214.598z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,223.286c-39.636,0-71.883,32.246-71.883,71.881c0,39.636,32.247,71.883,71.883,71.883 c39.636,0,71.883-32.247,71.883-71.883C327.883,255.532,295.636,223.286,256,223.286z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconSvg);
export default __webpack_public_path__ + "static/media/cameraIconSvg.c57689619035dc34446a1e2734f14be3.svg";
export { ForwardRef as ReactComponent };